<form [formGroup]='movingBoxes' (ngSubmit)='onSubmit()' id='{{formGroupName}}'>

	<div class='baggage-moving-size'>

		<div class='step-title' i18n><span class='color-blue'>How many</span> boxes are you moving?</div>
		<div class='baggage'>
			<div class='item' *ngFor='let size of baggageSizes'>
				<div class='item-left'>
					<div class='item-icon'>
						<mat-icon svgIcon='icons:objects'></mat-icon>
					</div>
					<div class='item-group'>
						<div class='item-title'>
							{{size.title}}
						</div>
						<div class='item-size'>
							{{size.size}}
						</div>
						<div class='item-desc' i18n='Max. {x kilograms}@@baggageItemDescription'>Max. {{size.descriptionSizeKg}}</div>
					</div>
				</div>
				<div class='item-right'>
					<div class='item-actions'>
						<div class='item-actions-minus'
						     [tabIndex]='formService.verifyTabIndex( formGroupName )'
						     (click)='itemDown( size.key )'
						     (keydown.enter)='itemDown( size.key )'
						     [class]='movingBoxes.controls[size.key].value === 0 ? "inactive" : ""'>
							<mat-icon svgIcon='vc:minus'></mat-icon>
						</div>
						<div class='item-actions-count'>
							<input
								type='number'
								(blur)='itemInput($event, size.key)'
								[value]='movingBoxes.controls[size.key].value'
								[tabIndex]='formService.verifyTabIndex( formGroupName )'>
						</div>
						<div class='item-actions-plus'
						     [tabIndex]='formService.verifyTabIndex( formGroupName )'
						     (keydown.enter)='itemUp( size.key )'
						     (click)='itemUp( size.key )'>
							<mat-icon svgIcon='vc:plus'></mat-icon>
						</div>
					</div>
				</div>
			</div>

			<div class='item item-custom'>
				<div class='item-icon'>
					<mat-icon svgIcon='icons:objects'></mat-icon>
				</div>
				<div class='item-content'>
					<div class='item-content-title' i18n>Other items</div>
					<div class='item-content-text' i18n>For luggage and other items, please describe here</div>
				</div>
				<div class='form-control'>
					<mat-form-field appearances='standard'>
						<input formControlName='customItems'
						       matInput
						       type='text'
						       [tabIndex]='formService.verifyTabIndex( formGroupName )'
						       placeholder='E.g. 1 box a 25 x 70 x 20 cm' i18n-placeholder='@@customItemsPlaceholder'>
					</mat-form-field>
				</div>

			</div>
		</div>

	</div>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit'
			        type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>

</form>